import * as React from "react";
import { useState, useEffect} from "react"
import PageContainerWide from "../core/PageContainerWide";
import Breadcrumbs from "../core/Breadcrumbs";
import { jfetch, toast } from "../../utils";
import { useParams, useHistory } from "react-router-dom";
import Button from "../core/Button";
import QuoteSummary from "./QuoteSummary"
import QuoteForm from "./QuoteForm"
import Sticky from 'react-sticky-el';
import QuickAddProduct from './QuickAddProduct'
import QuickAddService from './QuickAddService'
import QuickAddCharge from './QuickAddCharge'

interface IProps {
  userContext:any;
  services:any;
  products:any;
  charges:any;
  productCategories:any;
  serviceCategories:any;
  chargeCategories:any;
  projectServiceCategories:any;
  updateService: Function;
  updateProduct: Function;
  updateCharge: Function;
  company:string;
  contact:string;
  email:string;
  notes:string;
  sold:boolean;
  isHAAS:boolean;
  setCompany:Function;
  setContact:Function;
  setEmail:Function;
  setNotes:Function;
  setSold:Function;
  setHAAS:Function;
  servicesTotal:number;
  serviceProfit:number;
  productsTotal:number;
  productProfit:number;
  chargesTotal:number;
  chargeProfit:number;
  monthlyRevenue:number;
  monthlyProfit:number;
  dueAmount:number;
  monthlyExpense:number;
  setServices: Function;
  setProducts: Function;
  setCharges: Function;
  withHAAS:number;
  withoutHAAS:number;
  LLGM:number;
  modifier:number;
  setModifier:Function;
  burdenRate:number;
  billRate:number;
  ROI:number;
  setBurdenRate:Function;
  setBillRate:Function;
  setROI:Function;
  contractTerm: number;
  setContractTerm: Function;
  setProjectHours:Function;
  projectServices:any;
  setProjectServices:Function;
  updateProjectService:Function;
  projectHours:number;
  projectLaborRevenue:number;
  projectLaborExpense:number;
  chargesOnlyTotal:number;
}

function QuoteNew(props:IProps){
  const { calculator_id }:any = useParams()
  let history = useHistory()

  useEffect(() => {
    jfetch 
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/products`)
    .then((resp) => {
      props.setProducts(resp)
    })
    jfetch 
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/services`)
    .then((resp) => {
      props.setServices(resp, true)
    })
    jfetch 
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/project_services`)
    .then((resp) => {
      props.setProjectServices(resp)
    })    
    jfetch 
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/charges`)
    .then((resp) => {
      props.setCharges(resp)
    })    
  }, [])

  return (
    <div className="quote-new">
      <PageContainerWide>
        <Breadcrumbs
          crumbs={[
            {
              label: "Pricing Quote Dashboard",
              route: "/quote_calculator",
              routerLink: true,
            },
            {
              label: "Quotes",
              routerLink: true,
              route: `/quote_calculator/${calculator_id}/quotes/`
            },             
            { label: `New Quote` },
          ]}
        /> 
        <div className="row">
          <QuoteForm 
            services={props.services}
            products={props.products}
            charges={props.charges}
            productCategories={props.productCategories}
            serviceCategories={props.serviceCategories}
            chargeCategories={props.chargeCategories}
            projectServiceCategories={props.projectServiceCategories}
            updateService={props.updateService}
            updateProduct={props.updateProduct}
            updateCharge={props.updateCharge}
            company={props.company}
            contact={props.contact}
            email={props.email}
            notes={props.notes}
            sold={props.sold}
            isHAAS={props.isHAAS} 
            setCompany={props.setCompany}
            setContact={props.setContact}
            setEmail={props.setEmail}
            setNotes={props.setNotes}
            setSold={props.setSold}
            setHAAS={props.setHAAS}
            userContext={props.userContext}
            burdenRate={props.burdenRate}
            billRate={props.billRate}
            ROI={props.ROI}
            setBurdenRate={props.setBurdenRate}
            setBillRate={props.setBillRate}
            setROI={props.setROI}
            contractTerm={props.contractTerm}
            setContractTerm={props.setContractTerm}
            setProjectHours={props.setProjectHours}
            projectServices={props.projectServices}
            updateProjectService={props.updateProjectService}
            projectHours={props.projectHours}
            projectLaborRevenue={props.projectLaborRevenue}
            projectLaborExpense={props.projectLaborExpense}  
            servicesTotal={props.servicesTotal} 
            productsTotal={props.productsTotal} 
            chargesTotal={props.chargesTotal}  
            chargesOnlyTotal={props.chargesOnlyTotal}          
          />
          <div className="col-lg-3">
            <Sticky>
              <div style={{paddingTop:'67px'}}>
                <h4 style={{color:'black'}}>Quote Summary</h4>
                <div className="row">
                  <div className="col-lg-12">
                    <QuoteSummary 
                      servicesTotal={props.servicesTotal} 
                      serviceProfit={props.serviceProfit} 
                      productsTotal={props.productsTotal} 
                      productProfit={props.productProfit} 
                      chargesTotal={props.chargesTotal} 
                      chargeProfit={props.chargeProfit}
                      monthlyRevenue={props.monthlyRevenue} 
                      monthlyProfit={props.monthlyProfit}
                      dueAmount={props.dueAmount}
                      withHAAS={props.withHAAS}
                      withoutHAAS={props.withoutHAAS}
                      LLGM={props.LLGM}
                      modifier={props.modifier}
                      setModifier={props.setModifier}
                      burdenRate={props.burdenRate}
                      billRate={props.billRate}
                    />
                  </div>
                </div>
                <div className="row" style={{paddingTop:'15px'}} >
                  <div className="col-lg-12 text-left">
                    <Button 
                      color="primary"
                      onClick={() => {
                        let quote = {
                          quote: {
                            company: props.company,
                            contact: props.contact,
                            email: props.email,
                            notes: props.notes,
                            sold: props.sold,
                            services: props.services,
                            products: props.products,
                            charges: props.charges, 
                            project_services: props.projectServices,
                            user_id: props.userContext.user.id,
                            organization_id: props.userContext.org.id,
                            quote_calculator_quote_calculator_id: calculator_id,
                            monthly_revenue: props.monthlyRevenue,
                            monthly_expense: props.monthlyExpense,
                            monthly_profit: props.monthlyProfit,
                            service_profit: props.serviceProfit,
                            product_profit: props.productProfit,
                            charge_profit: props.chargeProfit,
                            amount_due: props.dueAmount,
                            is_haas: props.isHAAS,
                            modifier: props.modifier,
                            burden_rate:props.burdenRate,
                            bill_rate:props.billRate,
                            roi:props.ROI,
                            contract_term: props.contractTerm,
                            project_price: props.chargesTotal,
                            haas_price: props.withHAAS
                          }
                        }
                        jfetch.post(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}/quotes`, quote)
                        .then((resp) => {
                          history.push(`/quote_calculator/${calculator_id}/quotes/`)
                          toast.success('Your quote was created succesfully')
                        })
                      }}
                    >
                      Save Quote
                    </Button>
                  </div>
                </div>            
              </div>
            </Sticky>
          </div>
        </div>
        <QuickAddProduct productCategories={props.productCategories} setProducts={props.setProducts} />
        <QuickAddService serviceCategories={props.serviceCategories} setServices={props.setServices} />
        <QuickAddCharge chargeCategories={props.chargeCategories} setCharges={props.setCharges} />
      </PageContainerWide>
    </div>
  )
}

export default QuoteNew


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/QuoteNew.tsx